import { IconWrapper } from '../runtime';
export default IconWrapper('restore-window', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.25 10.749H12.75C13.5784 10.749 14.25 10.0775 14.25 9.24902L14.25 3.75153C14.25 2.9231 13.5784 2.25153 12.75 2.25153H6.25C5.42157 2.25153 4.75 2.9231 4.75 3.75153V5.25153M9.75 5.25153H3.25C2.42157 5.25153 1.75 5.9231 1.75 6.75153V12.249C1.75 13.0775 2.42157 13.749 3.25 13.749H9.75C10.5784 13.749 11.25 13.0775 11.25 12.249V6.75153C11.25 5.9231 10.5784 5.25153 9.75 5.25153Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});